<div class="material-panel">
  <div class="title">
    <h3>{{ 'ORDERS.MATERIAL.TITLE' | translate }}</h3>
  </div>

  <form [formGroup]="editMaterialForm" class="row">
    <eps-radio-group
      formControlName="type"
      [options]="typeOptions"
      [readonly]="!material.isNew"
      disabledProperty="disabled"
      label="ORDERS.MATERIAL.TYPE"
      [radioButtonsDirection]="(isMobilePortraitScreen$ | async) ? 'column' : 'row'"
      class="field col-12"
    ></eps-radio-group>

    <div class="col-12 hr"></div>

    <eps-select
      [options]="material.isNew ? palletIds : definitions.pallet.type"
      [freeze]="freezeFields"
      [readonly]="!material.isNew"
      formControlName="palletId"
      *ngIf="isCombination() || isPallet()"
      label="ORDERS.MATERIAL.LABELS.TYPE_PALLET"
      class="col-12 field"
      autoSelect
    ></eps-select>

    <eps-select
      [options]="material.isNew ? packingIds : definitions.packing.type"
      [freeze]="freezeFields"
      [readonly]="!material.isNew"
      formControlName="packingId"
      *ngIf="isCombination() || isPacking()"
      label="ORDERS.MATERIAL.LABELS.TYPE_PACKING"
      autoSelect
      class="col-12 field"
    ></eps-select>

    <eps-select
      [options]="material.isNew ? packingStatusses : definitions.packing.status"
      [freeze]="freezeFields"
      [readonly]="!material.isNew"
      formControlName="packingStatus"
      *ngIf="isCombination()"
      label="ORDERS.MATERIAL.LABELS.STATUS_PACKING"
      class="col-12 field"
      autoSelect
    ></eps-select>

    <eps-select
      [options]="material.isNew ? logisticsVarietyPackings : definitions.order.logisticsVarietyPacking"
      [freeze]="freezeFields"
      [readonly]="!material.isNew"
      formControlName="logisticsVarietyPacking"
      *ngIf="isCombination()"
      label="ORDERS.MATERIAL.LABELS.LOGISTIC_VARIETY"
      class="col-12 field"
      autoSelect
    ></eps-select>

    <eps-select
      [options]="material.isNew ? packingPerPalletList : definitions.order.packingPerPallet"
      [freeze]="freezeFields"
      [readonly]="!material.isNew"
      formControlName="packingsPerPallet"
      *ngIf="isCombination()"
      label="ORDERS.MATERIAL.LABELS.PACKING_PER_PALLET"
      autoSelect
      class="col-12 field"
    ></eps-select>

    <eps-number-input
      label="ORDERS.MATERIAL.LABELS.NUMBER_OF_PALLETS"
      formControlName="numberOfPallets"
      class="col-12 field"
      *ngIf="isCombination() || isPallet()"
    ></eps-number-input>

    <eps-number-input
      label="ORDERS.MATERIAL.LABELS.QUANTITY"
      formControlName="packingQuantity"
      class="col-12 field"
      *ngIf="isPacking()"
    ></eps-number-input>

    <div class="col-12 hr no_margin_bottom"></div>

    <div class="col-12 hr"></div>

    <div class="col-12 buttons">
      <eps-button
        [disabled]="saving || editMaterialForm.invalid"
        [busy]="saving"
        (buttonClick)="nextClickedFn()"
        submit
        [buttonIcon]="panelStatus.isNew ? 'plus' : null"
        [label]="material.internalId?'SHARED.BUTTONS.SAVE':'ORDERS.MATERIAL.BUTTONS.ADD_MATERIAL'"
      ></eps-button>
    </div>
  </form>
</div>
